import React from 'react'
import { Container, Text } from 'rsuite'
import cx from 'classnames'
import tenantConfig from 'config/tenant'
import './SectionLoader.scss'

export interface SectionSpinnerProps {
  message?: string;
  className?: string;
}

export const SectionLoader: React.FC<SectionSpinnerProps> = ({
  message,
  className = ''
}) => (
  <Container className={cx('spinner', className)} data-testid="section-loader">
    <div className="loader-wrapper">
      <div className="section-loader-mark">
        <span className="section-loader-mark__ring" aria-hidden />
        <img
          className="section-loader-mark__icon"
          src={tenantConfig.logoIcon}
          alt={tenantConfig.name}
        />
      </div>
      <Text size="lg">{message ?? 'Loading, please wait...'}</Text>
    </div>
  </Container>
)

export default SectionLoader
